/** Conversión de celdas devueltas por la API de Sheets (UNFORMATTED_VALUE + SERIAL_NUMBER). */

const EPOCH = Date.UTC(1899, 11, 30);

/** Número de serie de fecha de Sheets → 'yyyy-MM-dd' ('' si no es fecha). */
export function serialToIso(v: unknown): string {
  if (typeof v === 'number' && Number.isFinite(v) && v > 0) return new Date(EPOCH + Math.floor(v) * 86400000).toISOString().slice(0, 10);
  if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v.trim())) return v.trim();
  if (typeof v === 'string') {
    const m = v.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (m) return `${m[3]}-${m[2]!.padStart(2, '0')}-${m[1]!.padStart(2, '0')}`;
  }
  return '';
}

export function isoToSerial(iso: string): number {
  return Math.round((Date.parse(`${iso}T00:00:00Z`) - EPOCH) / 86400000);
}

export function text(v: unknown): string {
  return v === null || v === undefined ? '' : String(v).trim();
}

export function num(v: unknown): number | null {
  if (typeof v === 'number' && Number.isFinite(v)) return v;
  if (typeof v === 'string' && v.trim() !== '') { const n = Number(v.replace(',', '.')); return Number.isFinite(n) ? n : null; }
  return null;
}

export function bool(v: unknown): boolean {
  return v === true || (typeof v === 'string' && ['true', 'verdadero', 'si', 'sí', 'x'].includes(v.trim().toLowerCase()));
}

/** "Mes (opcional)": texto 'yyyy-MM' o, si Sheets lo convirtió en fecha, el mes de esa fecha. */
export function monthCell(v: unknown): string {
  if (typeof v === 'number') return serialToIso(v).slice(0, 7);
  return text(v);
}

export function isBlankRow(r: unknown[] | undefined): boolean {
  return !r || r.every(v => v === '' || v === null || v === undefined);
}

/** Hash corto y estable (FNV-1a de 32 bits ×2, 12 hex). */
export function hash12(s: string): string {
  let h1 = 0x811c9dc5, h2 = 0x01000193;
  for (let i = 0; i < s.length; i++) {
    h1 = Math.imul(h1 ^ s.charCodeAt(i), 16777619) >>> 0;
    h2 = Math.imul(h2 ^ s.charCodeAt(i), 2246822519) >>> 0;
  }
  return (h1.toString(16).padStart(8, '0') + h2.toString(16).padStart(8, '0')).slice(0, 12);
}

/** Fórmula comparable: sin espacios, ',' en vez de ';' y mayúsculas, salvo dentro de comillas. */
export function normalizeFormula(f: string): string {
  let out = '', q = false;
  for (const c of String(f ?? '')) {
    if (c === '"') { q = !q; out += c; continue; }
    if (q) { out += c; continue; }
    if (/\s/.test(c)) continue;
    out += c === ';' ? ',' : c.toUpperCase();
  }
  return out;
}
